import { Box, Tabs } from "@mui/material";
import Tab from "@mui/material/Tab";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FluxoModel } from "../../types/fluxo/types";
import { TabPanelProps } from "../../types/helpers/types";
import Accomplish from "./Accomplish";
import CreateAndEdit from "./CreateAndEdit";
import Cadastros from "./Cadastros";
import AgendamentosPendentes from "./AgendamentosPendentes";

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function FluxoTabs() {
  const { t } = useTranslation("translation");
  const [value, setValue] = useState<number>(0);
  const [fluxoParaEditar, setFluxoParaEditar] = useState<
    FluxoModel | undefined
  >(undefined);

  function handleChange(event: React.SyntheticEvent, newValue: number) {
    setValue(newValue);
  }

  function handleEditContent(fluxo: FluxoModel) {
    setFluxoParaEditar(fluxo);
    setValue(0);
  }

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab value={0} label={t("fluxo.create")} />
          <Tab value={1} label={t("fluxo.acompanhamento")} />
          <Tab value={2} label={t("fluxo.registrations.title")} />
          <Tab value={3} label="Agendamentos Pendentes" />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <CreateAndEdit
          fluxoParaEditar={fluxoParaEditar}
          setFluxoParaEditar={setFluxoParaEditar}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Accomplish handleEditContent={handleEditContent} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Cadastros />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <AgendamentosPendentes />
      </CustomTabPanel>
    </>
  );
}
